import { render, staticRenderFns } from "./TotalWinToLossRatio.vue?vue&type=template&id=254ea59c&"
import script from "./TotalWinToLossRatio.vue?vue&type=script&lang=js&"
export * from "./TotalWinToLossRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports